import React from "react";
import PropTypes from "prop-types";
import Markdown from 'markdown-to-jsx';
import { Modal, Button } from "react-bootstrap";
import Image from "components/Image";
import Icon from "./Icon";

const HalsbandDetailDialog = (
  {
    onHide,
    imageFileName,
    imageAlt,
    header,
    subheader,
    content,
    extraInfo,
    youtubeVideoId,
    ...restProps
  }
) => {
  return (
    <Modal
      {...restProps}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mx-auto">
        <p className="item-intro text-muted">{subheader}</p>

        {
          youtubeVideoId ? (
            <div className="cc-youtube-video">
              <iframe
                title="youtube"
                src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&theme=dark&modestbranding=1&showinfo=0&rel=0`}
                frameBorder="0"
                allowFullScreen />
            </div>
          ) : (
            <Image
              className="img-fluid d-block"
              fileName={imageFileName}
              alt={imageAlt || header || subheader}
            />
          )
        }

        {
          content && (
            <div><Markdown>{content}</Markdown></div>
          )
        }

        {extraInfo}
      </Modal.Body>
      <Modal.Footer>
        <div className="mx-auto">
          <Button variant="primary" onClick={onHide}>
            <Icon iconName="CloseIcon" />
            &nbsp; Close Project
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

HalsbandDetailDialog.propTypes = {
  onHide: PropTypes.func,
  imageFileName: PropTypes.string,
  imageAlt: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.string,
  content: PropTypes.string,
  extraInfo: PropTypes.any,
  youtubeVideoId: PropTypes.string,
};

HalsbandDetailDialog.defaultProps = {
  onHide: null,
  imageFileName: "",
  imageAlt: null,
  header: "",
  subheader: "",
  content: "",
  extraInfo: null,
  youtubeVideoId: ""
};

export default HalsbandDetailDialog;
